import { EuiFlexGroup, EuiIcon } from "@inscopix/ideas-eui";
import { nodeStyles } from "./nodeStyles";

export const NodeIcon = ({ type, label }: { type: string; label: string }) => (
  <EuiFlexGroup
    alignItems="center"
    justifyContent="flexEnd"
    style={nodeStyles.headerFlexContainer}
    gutterSize="none"
  >
    <EuiIcon
      type={type}
      size="m"
      color="inherit"
      title={label}
      style={{ marginTop: 5, marginRight: 5 }}
    />
  </EuiFlexGroup>
);
